import { ReactElement } from 'react';
import { addMonths, differenceInDays, differenceInMonths, format, parseISO } from 'date-fns';
import { Box, BoxProps } from '@ff-it/ui';

type PeriodWidgetProps = {
  // when do we ever supprot incomplete periods?
  date_from: string;
  date_to: string;
  distance?: boolean;
  // month?
} & BoxProps;

function dist(from: Date, to: Date): string {
  const parts = [];
  const months = Math.abs(differenceInMonths(to, from));
  if (months > 0) {
    parts.push(`${months}m`);
  }

  const afterMonths = addMonths(from, months);
  const days = Math.abs(differenceInDays(to, afterMonths)) + 1;
  if (days > 0) {
    parts.push(`${days}d`);
  }

  return parts.join(' ');
}

export function PeriodWidget({ date_from, date_to, distance, ...rest }: PeriodWidgetProps): ReactElement {
  const startDate = parseISO(date_from);
  const endDate = parseISO(date_to);

  let startFormat = 'dd.MM.yyyy';
  if (startDate.getFullYear() === endDate.getFullYear()) {
    if (startDate.getMonth() === endDate.getMonth()) {
      startFormat = 'dd.';
    } else {
      startFormat = 'dd.MM.';
    }
  }
  const start = format(startDate, startFormat);
  const end = format(endDate, 'dd.MM.yyyy');

  return (
    <Box as="span" data-date_from={date_from} data-date_to={date_to} whiteSpace="nowrap" {...rest}>
      {start} - {end}
      {distance && (
        <Box as="span" display="inline" ml="1" color="gray500">
          {dist(startDate, endDate)}
        </Box>
      )}
    </Box>
  );
}
